import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonsModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
import { DocumentDropEmitterDirective } from './documentdropemitter.directive';
import { DocumentDragOverlayDirective } from './dragOverlay.directive';
import { UploadComponent } from './fileupload.component';
import { AlertModule } from '../alert/alert.module';
import { FileuploadAlertComponent } from './fileupload-alert.component';

@NgModule({
  imports: [CommonModule, FormsModule, ButtonsModule, IconModule, AlertModule],
  declarations: [
    UploadComponent,
    DocumentDropEmitterDirective,
    DocumentDragOverlayDirective,
    FileuploadAlertComponent
  ],
  exports: [
    UploadComponent,
    DocumentDropEmitterDirective,
    DocumentDragOverlayDirective,
    FileuploadAlertComponent
  ],
  entryComponents: [FileuploadAlertComponent]
})
export class FileUploadModule { }
